import {inject, Injectable} from '@angular/core';
import {TRANSLATE} from '@brunata-angular/util';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {ModalInputService} from '../modal-input/modal-input.service';

interface ConfirmationDialogSettings {
    title: string;
    message: string;
    btnOkText?: string;
    btnCancelText?: string;
    showCancel?: boolean;
    centered?: boolean;
    backdrop?: 'static' | boolean;
    /** When set, the confirm button stays disabled until the user ticks this checkbox. */
    checkboxLabel?: string;
}

@Injectable({
    providedIn: 'root',
})
export class ConfirmationDialogService {
    private readonly modalInputService = inject(ModalInputService);
    private readonly translate = inject(TRANSLATE);

    public confirm(
        title: string,
        message: string,
        btnOkText?: string,
        btnCancelText?: string,
    ): Promise<boolean> {
        return this.confirmWithSettings({title, message, btnOkText, btnCancelText});
    }

    public confirmWithSettings(settings: ConfirmationDialogSettings): Promise<boolean> {
        const {modalRef} = this.modalInputService.open(
            ConfirmationDialogComponent,
            {
                title: settings.title,
                message: settings.message,
                btnOkText: settings.btnOkText ?? this.translate('reporting_CONTINUE'),
                btnCancelText: settings.btnCancelText ?? this.translate('reporting_CANCEL'),
                showCancel: settings.showCancel,
                checkboxLabel: settings.checkboxLabel,
            },
            {
                size: 'md',
                backdrop: settings.backdrop ?? 'static',
                centered: settings.centered,
            },
        );

        return modalRef.result.catch(() => false);
    }
}
